import React from 'react';
import { Circle, Check, Svg } from '../styled';
import { ProcessingProps } from '../types';
import { useTranslation } from 'react-i18next';

/**
 * Processing is an animated SVG that has a loading circle, until the props.complete is true,
 * in which the circle draws itself in and a checkmark is drawn in
 */

export const Processing = (props: ProcessingProps) => {
  const { complete, size, onAnimationComplete } = props;
  const { t } = useTranslation();

  if (complete && onAnimationComplete) setTimeout(onAnimationComplete, 3000);

  return (
    <Svg viewBox="0 0 60 60" size={size} complete={complete}>
      <title>{t('processing.processingTitle')}</title>
      <Circle cx="30" cy="30" r="27.5356" />
      <Check points="42.873 20.259 24.02 39.112 14.442 29.534" />
    </Svg>
  );
};

Processing.defaultProps = {
  size: 240
};
